import React, {Fragment} from 'react';
import {Chart} from 'react-google-charts';
import PropTypes from 'prop-types';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

class AssessmentLineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lineData: [],
      chartOptions: {},
      show: this.props.coachScores.length >= 2 || this.props.groupScores.length >= 2
    };
  }

  async componentDidMount() {
    if(this.state.show) {
      let lineData = [
        [{type: 'date', label: 'Date'}, {label: 'Coach', type: 'number'}, {label: 'Team', type: 'number'},
          // {label: 'Team Dynamics', type: 'number'}, {label: 'Team Structure', type: 'number'}, {label: 'Product', type: 'number'}, {label: 'Agile Process Mechanics', type: 'number'}, {label: 'Agile Engineering Practices', type: 'number'}
        ]
      ];

      this.props.coachScores.forEach(s => {
        // let subscores = [];
        // for (let i = 1; i < 6; i++) {
        //   subscores.push((s.subscores.find(ss => ss.subsection_id === i) || {}).score || null);
        // }
        const data = [new Date(s.assessment_date), s.calculated_score, null,
          // ...subscores
        ];
        lineData.push(data);
      });


      this.props.groupScores.forEach(s => {
        // let subscores = [];
        // for (let i = 1; i < 6; i++) {
        //   subscores.push((s.subscores.find(ss => ss.subsection_id === i) || {}).score || null);
        // }
        const data = [new Date(s.assessment_date), null, s.calculated_score,
          // ...subscores
        ];
        lineData.push(data);
      });

      let gDate;
      if(this.props.groupScores.isDefined) {
        gDate = this.props.groupScores[0].assessment_date;
      }else {
        gDate = this.props.startDate;
      }
      let cDate;
      if(this.props.coachScores.isDefined){
        cDate = this.props.coachScores[0].assessment_date;
      }else {
        cDate = this.props.startDate;
      }

      let minDate = new Date(this.props.startDate);
      if(minDate > cDate) {
        minDate = cDate;
      }
      if(minDate > gDate) {
        minDate = gDate;
      }

      const chartOptions = {
        interpolateNulls: true,
        title: 'Team Trend',
        vAxis: {title: 'Score', minValue: 0, maxValue: 100},
        hAxis: {
          title: 'Date',
          format: 'MMM, d y',
          minValue: minDate,
        },
        // seriesType: 'bars',
        // series: { 0: { type: 'line' }, 1: { type: 'line' }},
        explorer: {
          actions: ['dragToZoom', 'rightClickToReset'],
          axis: 'horizontal',
          keepInBounds: true,
          maxZoomIn: 20},

      };

      this.setState({lineData, chartOptions});
    }
  }



  render() {
    return (
      <div className='line-chart'>
        { this.state.show
          ?
          <Fragment>
            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"> Click and drag to zoom in, right click to zoom out. </Tooltip> }>
              <i className="fas fa-question-circle"/>
            </OverlayTrigger>
            <Chart
              // chartType="ComboChart"
              chartType="LineChart"
              data={this.state.lineData}
              options={this.state.chartOptions}
              width="100%"
              height="300px"
            />
          </Fragment>
          :
          <p className="mt2 ta-center">Complete at least two assessments of the same type to see trend line.</p>
        }
      </div>
    );
  }
}

AssessmentLineChart.propTypes = {
  coachScores: PropTypes.array,
  groupScores: PropTypes.array,
};

export default AssessmentLineChart;


// WEBPACK FOOTER //
// ./src/components/teams/AssessmentLineChart.js